// extracted by mini-css-extract-plugin
export default {"container":"PriceTiers_container__cInG2","title":"PriceTiers_title__xZGMQ","priceTiersTable":"PriceTiers_priceTiersTable__Rjn5+"};